import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScreenService implements OnDestroy {
  private mql: MediaQueryList;
  private listener: (e: MediaQueryListEvent) => void;
  
  public isMobile$ = new BehaviorSubject<boolean>(false);

  constructor() {
    this.mql = window.matchMedia('(max-width: 768px)');
    this.isMobile$.next(this.mql.matches);

    this.listener = (e: MediaQueryListEvent) => {
      this.isMobile$.next(e.matches);
    };

    this.mql.addEventListener('change', this.listener);
  }

  ngOnDestroy() {
    this.mql.removeEventListener('change', this.listener);
  }
}
